<template>
   <div>
     <TopoComponent :empresa="nomeempresa"></TopoComponent>
     <h3>Redirecionando ...</h3>
  </div>   
</template>

<script>
export default {
  name: 'alterarSenhaLoad',
  props: ['token','empresa'],
  data() {
    return { 
        nomeempresa: null
    }
  },
  created(){
    this.nomeempresa = this.empresa
    this.carregarSessaoUsuario()
  },
  methods : {
    carregarSessaoUsuario(){
        this.$conexaApi.get('/usuario/auth/redirecionamento/'+this.token, {
        }).then((response) => {
           sessionStorage.setItem("usuarioNome", response.data.object.usuario.nome) 
           sessionStorage.setItem("usuarioToken", response.data.object.token) 
           location.href = '/alterar-senha/form/'+this.nomeempresa
        }).catch((error) => {
            this.$notify({
                duration: 4000,
                group: 'mensagens',
                type: 'error', 
                title: 'Mensagem',
                text: error.response.data.msg
            })
        }).finally(() => {
            NProgress.done()
        }) 
    }
  }
}
</script>